import { render, staticRenderFns } from "./EmailReminder.vue?vue&type=template&id=4f325f85&scoped=true&"
import script from "./EmailReminder.vue?vue&type=script&lang=js&"
export * from "./EmailReminder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f325f85",
  null
  
)

export default component.exports